import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
import vuescrollto from './plugins/vue-scrollto'

Vue.config.productionTip = false
Vue.config.devtools = true

new Vue({
  router,
  vuetify,
  store,
  vuescrollto,
  render: h => h(App)
}).$mount('#app')
